/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationTreeNodeDto
 */
export interface OrganizationTreeNodeDto {
    /**
     * 
     * @type {string}
     * @memberof OrganizationTreeNodeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationTreeNodeDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationTreeNodeDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationTreeNodeDto
     */
    parentId: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationTreeNodeDto
     */
    organizationType: OrganizationTreeNodeDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationTreeNodeDto
     */
    mainLanguage: OrganizationTreeNodeDtoMainLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationTreeNodeDto
     */
    createdById?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationTreeNodeDto
     */
    updatedById?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationTreeNodeDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationTreeNodeDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof OrganizationTreeNodeDto
     */
    depth: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationTreeNodeDto
     */
    isRoot: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationTreeNodeDto
     */
    isLeaf: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationTreeNodeDto
     */
    isInternal: boolean;
    /**
     * 
     * @type {Array<OrganizationTreeNodeDto>}
     * @memberof OrganizationTreeNodeDto
     */
    children: Array<OrganizationTreeNodeDto>;
}


/**
 * @export
 */
export const OrganizationTreeNodeDtoOrganizationTypeEnum = {
    Operator: 'Operator',
    Manufacturer: 'Manufacturer',
    Landlord: 'Landlord',
    Oem: 'OEM'
} as const;
export type OrganizationTreeNodeDtoOrganizationTypeEnum = typeof OrganizationTreeNodeDtoOrganizationTypeEnum[keyof typeof OrganizationTreeNodeDtoOrganizationTypeEnum];

/**
 * @export
 */
export const OrganizationTreeNodeDtoMainLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type OrganizationTreeNodeDtoMainLanguageEnum = typeof OrganizationTreeNodeDtoMainLanguageEnum[keyof typeof OrganizationTreeNodeDtoMainLanguageEnum];


/**
 * Check if a given object implements the OrganizationTreeNodeDto interface.
 */
export function instanceOfOrganizationTreeNodeDto(value: object): value is OrganizationTreeNodeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('mainLanguage' in value) || value['mainLanguage'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('depth' in value) || value['depth'] === undefined) return false;
    if (!('isRoot' in value) || value['isRoot'] === undefined) return false;
    if (!('isLeaf' in value) || value['isLeaf'] === undefined) return false;
    if (!('isInternal' in value) || value['isInternal'] === undefined) return false;
    if (!('children' in value) || value['children'] === undefined) return false;
    return true;
}

export function OrganizationTreeNodeDtoFromJSON(json: any): OrganizationTreeNodeDto {
    return OrganizationTreeNodeDtoFromJSONTyped(json, false);
}

export function OrganizationTreeNodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationTreeNodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'active': json['active'],
        'parentId': json['parentId'],
        'organizationType': json['organizationType'],
        'mainLanguage': json['mainLanguage'],
        'createdById': json['createdById'] == null ? undefined : json['createdById'],
        'updatedById': json['updatedById'] == null ? undefined : json['updatedById'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'depth': json['depth'],
        'isRoot': json['isRoot'],
        'isLeaf': json['isLeaf'],
        'isInternal': json['isInternal'],
        'children': ((json['children'] as Array<any>).map(OrganizationTreeNodeDtoFromJSON)),
    };
}

export function OrganizationTreeNodeDtoToJSON(json: any): OrganizationTreeNodeDto {
    return OrganizationTreeNodeDtoToJSONTyped(json, false);
}

export function OrganizationTreeNodeDtoToJSONTyped(value?: OrganizationTreeNodeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
        'parentId': value['parentId'],
        'organizationType': value['organizationType'],
        'mainLanguage': value['mainLanguage'],
        'createdById': value['createdById'],
        'updatedById': value['updatedById'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'depth': value['depth'],
        'isRoot': value['isRoot'],
        'isLeaf': value['isLeaf'],
        'isInternal': value['isInternal'],
        'children': ((value['children'] as Array<any>).map(OrganizationTreeNodeDtoToJSON)),
    };
}

